import { atom } from 'recoil';

export type ToastState = {
  visible: boolean;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  timer: any;
};
export const initialState: ToastState = {
  visible: false,
  message: '',
  timer: null,
};

export const toastState = atom({
  key: 'toastState',
  default: initialState,
});
